/** Same-origin API base (Firebase Hosting rewrites /api → Cloud Functions). */
export const API_URL = process.env.REACT_APP_APP_URL || '/api';

export async function parseCheckoutResponse(response) {
  const data = await response.json();
  if (!response.ok || !data.url) {
    const message = data.error || data.message || 'No checkout URL received';
    throw new Error(message);
  }
  return data.url;
}
